// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production : false,
  name: 'dev'
};

// I.C.V. CarlosPaH Encriptación datos Ene 2026
export const paramsSeguridad= {
        perfilUsuario: "U2FsdGVkX18K3NsCC0nCajJpqbGtGROf38oLvqEgr40=",
        tipoEmpleadorId: "U2FsdGVkX19GMCcK8/ka/K0kV3QGAV+F/5IGv0xSuuk=",
        empleadorId: "U2FsdGVkX19xX021Y8UiezRr1PTjMT4es4+Bmd/Blr8=",
        tipoDocumentoId: "U2FsdGVkX1++SMGeBKB8mh4Gd7RHHQxGnNlLrmdtZx4=",
        documentoId: "U2FsdGVkX19Mfh7sOfC5/Q9g3HbgVZTkTB97atn5ojk=",
        clave: "U2FsdGVkX1+9p0Q8mhbSJA9XKJ9vmEnLw8W6tb3TshA=",
        aplicativo:"U2FsdGVkX1+CW3f6+nxc659kURYQzYzhtcxR/kLM73A="
    }
// F.C.V. CarlosPaH Encriptación datos Ene 2026

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
